import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Container, Grid, Autocomplete, TextField } from "@mui/material";

// import logo from "../../../assets/safe_truck_small_logo.png";
import logo from "../../../assets/safe_logo.png";
import CustomTextField from "../../../components/CustomTextField";
import { ReactComponent as ArrowLeftSvg } from "../../../assets/svg/arrow-left.svg";
import RoundButton from "../../../components/RoundButton";
import {
  postalCodeValidationRequest,
  stateListRequest,
} from "../../../redux/signup/action";
import companyObject from "../../../utils";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

import operatorAddressScheme from "../../../validations/operatorAddressScheme";
import { operatorSignUpRequest } from "../../../redux/operator/action";
import { useResponsive } from "../../../hooks/useResponsive";
import background_image from "../../../assets/png/background_image.png";
import storePersist, { localConstant } from "../../../services/localStorage";
import { useTranslation } from "react-i18next";

const OperatorAddressDetails = () => {
  const { t } = useTranslation();

  const { stateObject } = useSelector((state) => state.signUpReducer);
  const { operatorAddressDetails } = useSelector(
    (state) => state.operatorReducer,
  );
  const { inviteDriverDetails } = useSelector(
    (state) => state.verifyUserReducer,
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lgUp = useResponsive("up", "lg");
  const smDown = useResponsive("down", "sm");

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    mode: "all",
    defaultValues: operatorAddressDetails,
    resolver: yupResolver(operatorAddressScheme),
  });

  useEffect(() => {
    dispatch(stateListRequest({}, () => {}));
  }, []);

  const formCompanyDetails = (values) => {
    const { isCompany, status, ...object } = companyObject;

    const operatorSignUpDetails = storePersist.get(
      localConstant.OPERATOR_SIGN_UP_DETAILS,
      values,
    );

    let data = {
      ...object,
      ...inviteDriverDetails,
      ...values,
      creationUser: "system",
      lastUpdatedUser: "system",
      token: inviteDriverDetails.token,
      customerId: inviteDriverDetails.customerId,
      phone: operatorSignUpDetails?.phone,
      password: operatorSignUpDetails?.password,
      userEmail: inviteDriverDetails.email,
      firstName: operatorSignUpDetails?.firstName,
      middleName: operatorSignUpDetails?.middleName,
      lastName: operatorSignUpDetails?.lastName,
    };

    const postalParamData = {
      addressLine1: values?.addressLine1,
      state: values?.stateCode,
      country: "USA",
      postalCode: values?.postalCode,
    };

    dispatch(
      postalCodeValidationRequest(postalParamData, (response) => {
        if (response?.postalCode) {
          dispatch(
            operatorSignUpRequest(data, (res) => {
              if (res?.user) {
                navigate("/uploadDocuments");
              }
            }),
          );
        }
      }),
    );
  };

  const renderCompanyDetails = (
    <>
      <Grid container sx={{ mb: 3 }} direction={"row"}>
        <ArrowLeftSvg
          style={{ alignSelf: "center" }}
          onClick={() => {
            navigate(-1);
          }}
        />
        <Typography sx={{ ml: 1 }} variant="titleText" color="primary.main">
          {t("pages.operatorAddressDetails.pageHeading")}
        </Typography>
      </Grid>
      <Stack spacing={1}>
        <Controller
          name="addressLine1"
          control={control}
          render={({ field }) => (
            <CustomTextField
              {...field}
              required
              placeholder={t("pages.operatorAddressDetails.text01")}
              label={t("pages.operatorAddressDetails.text01")}
              name="addressLine1"
              type="text"
              error={!!errors.addressLine1}
              helperText={errors.addressLine1?.message}
            />
          )}
        ></Controller>
        <Controller
          name="postalCode"
          control={control}
          render={({ field }) => (
            <CustomTextField
              label={t("pages.operatorAddressDetails.text02")}
              {...field}
              placeholder={t("pages.operatorAddressDetails.text02")}
              required
              name="postalCode"
              type="number"
              error={!!errors.postalCode}
              helperText={errors.postalCode?.message}
            />
          )}
        ></Controller>
        <Controller
          name="city"
          control={control}
          render={({ field }) => (
            <CustomTextField
              label={t("pages.operatorAddressDetails.text03")}
              {...field}
              required
              placeholder={t("pages.operatorAddressDetails.text03")}
              name="city"
              type="text"
              error={!!errors.city}
              helperText={errors.city?.message}
            />
          )}
        ></Controller>
        <Controller
          name="stateCode"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Box>
              <Typography
                variant="customLable"
                color="common.inputCustomLable"
                marginBottom={1}
                style={{ fontSize: "14px" }}
              >
                {t("pages.companyDetails.text08")}
                <span style={{ color: "#C50F1F" }}>*</span>
              </Typography>

              <Autocomplete
                name="state"
                options={stateObject?.USA?.map((item, index) => {
                  return {
                    value: item?.code,
                    label: item?.description,
                  };
                })}
                getOptionLabel={(option) => option?.label}
                isOptionEqualToValue={(option, value) =>
                  option?.label === value?.label
                }
                onChange={(event, item) => {
                  onChange(item?.label);
                  setValue("stateCode", item?.value);
                }}
                renderInput={(params) => (
                  <TextField
                    name="state"
                    {...params}
                    error={!!errors.state}
                    helperText={errors.state?.message}
                    fullWidth
                  />
                )}
              />
            </Box>
          )}
        ></Controller>
      </Stack>
    </>
  );

  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{
        paddingTop: 20,
        paddingBottom: 20,
        position: "relative",
        minHeight: "100vh",
        backgroundColor: "#80BCFF4F",
        backgroundImage: `url(${background_image})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        height: "100vh",
      }}
    >
      <Box
        maxWidth="xs"
        sx={{
          flexGrow: 1,
          minHeight: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            flexDirection: ["column", "column", "row"],
          }}
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{ height: 1, padding: 0 }}
          >
            <img src={logo} alt="Your Alt Text" />
            <Card
              sx={{
                p: 3,
                width: 1,
                maxWidth: 430,
                marginBottom: lgUp ? "10px" : "0px",
              }}
              style={{
                position: "absolute",
                top: "25%",
                bottom: 0,
                overflow: "auto",
              }}
              className="form_container"
            >
              <form onSubmit={handleSubmit((data) => formCompanyDetails(data))}>
                {renderCompanyDetails}
                <RoundButton
                  sx={{ mt: 15, mb: 10 }}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  color="inherit"
                >
                  <Typography variant="buttonText" color="common.buttonText">
                    {t("commonLabels.text01")}
                  </Typography>
                </RoundButton>
              </form>
            </Card>
          </Stack>
        </Box>
      </Box>
    </Container>
  );
};

export default OperatorAddressDetails;
